<script setup lang="ts">
import type { SelectTriggerProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { Icon } from '~ds/components/ui/icon'
import { ICONS } from '~ds/lib/icons'
import { cn } from '~ds/lib/utils'
import { SelectIcon, SelectTrigger, useForwardProps } from 'reka-ui'

import { selectTriggerVariants } from '.'

const props = withDefaults(
  defineProps<SelectTriggerProps & { class?: HTMLAttributes['class']; size?: 'sm' | 'default' }>(),
  { size: 'default' },
)

const delegatedProps = reactiveOmit(props, 'class', 'size')
const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    data-slot="select-trigger"
    :data-size="size"
    v-bind="forwardedProps"
    :class="cn(selectTriggerVariants({ size }), props.class)"
  >
    <slot />
    <SelectIcon as-child>
      <Icon
        :name="ICONS.arrowDown"
        size="sm"
        class="opacity-50"
      />
    </SelectIcon>
  </SelectTrigger>
</template>
